// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var textContainer = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.midGrey),
      BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.flexDirection("column"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [
            BsCssJs$PrezzeeRibbon.flexGrow(1),
            BsCssJs$PrezzeeRibbon.flexShrink(1),
            BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(20))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
            BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(50)),
            BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.px(630)),
            BsCssJs$PrezzeeRibbon.justifyContent("center")
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, [BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.pct(50))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [BsCssJs$PrezzeeRibbon.maxWidth("none")])
    ]);

var Style = {
  textContainer: textContainer
};

function TheGiftExperience__TextContainer(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: textContainer
            });
}

var make = TheGiftExperience__TextContainer;

export {
  Style ,
  make ,
}
/* textContainer Not a pure module */
